import { IntegrationStepLogTable } from "components/Tables/IntegrationStepLogTable/IntegrationStepLogTable";
import { TenantPage } from "components/UI/TenantPage/TenantPage";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/log/_layout/api/")({
    component: IntegrationStepLogPage,
    staticData: {
        permissions: [PermissionEnum.StepLogIntegrationsView],
        showInSideMenu: false,
        label: "pages.log.api.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.api.title"),
        };
    },
});

function IntegrationStepLogPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <IntegrationStepLogTable />
        </TenantPage>
    );
}
